








































































import { Vue, Component, Prop, Ref, Mixins } from "vue-property-decorator";

import LessonScore from "@/components/ReportResultTable/Score.vue";

import { ILessonReport } from "@/models/interfaces/report-generator";
import { mergeAll, uniq } from "ramda";
import ReportsMixin from "./Reports.mixin";

@Component({
  components: {
    LessonScore
  }
})
export default class LessonReport extends Mixins<ReportsMixin<ILessonReport>>(
  ReportsMixin
) {
  private keys = [
    {
      value: "100%",
      color: "#87c040"
    },
    {
      value: "50 - 99%",
      color: "#f3a945"
    },
    {
      value: "0 - 49%",
      color: "#e90c6e"
    },
    {
      value: "0% / not attempted",
      color: ""
    }
  ];

  private get lesson() {
    return this.reportData.lesson;
  }

  private get tableColumns() {
    return [
      {
        value: "firstname",
        label: "First name"
      },
      {
        value: "lastname",
        label: "Last name"
      },
      {
        value: "username",
        label: "Username"
      },
      {
        value: "lesson",
        label: this.lesson?.title,
        name: "lesson",
        custom: true
      }
    ];
  }

  private generateCsvFile() {
    const scoreActivities: string[] = [];

    this.reportData.users.forEach(item => {
      item.scores.forEach(score => {
        scoreActivities.push(score.activityId);
      });
    });

    let scoreHeaders: Record<string, string> = {};

    uniq(scoreActivities).forEach((activity, idx) => {
      scoreHeaders = Object.assign(scoreHeaders, {
        [`score${idx}`]: `Scores - ${activity}`
      });
    });

    const headers = {
      firstname: "First name",
      lastname: "Last name",
      username: "Username",
      ...scoreHeaders
    };

    const getFormattedScore = (total: number, achieved: number) => {
      const value = (achieved / total) * 100;
      return `${(value || 0).toFixed(0)}%`;
    };

    const data =
      this.reportData.users.map(item => ({
        firstname: item.firstname,
        lastname: item.lastname,
        username: item.username,
        ...mergeAll(
          item.scores.map((score, idx) => ({
            [`score${idx}`]: getFormattedScore(
              score.totalScore,
              score.userScore
            )
          }))
        )
      })) || [];

    this.exportCSVFile(headers, data, this.title);
  }
}
